import type { MenuListEntry } from "@/components/Menu/Menu";
import { getActiveBackendSource, getBackendSourceLabel, isBackendSourceToggleAvailable } from "./resolve";
import { type BackendSource, persistBackendSource } from "./storage";

function buildBackendSourceItem(source: BackendSource, active: BackendSource): MenuListEntry {
  const label = getBackendSourceLabel(source);

  return {
    label,
    ariaLabel: active === source ? `Selected API backend: ${label}` : `Switch API backend to ${label}`,
    iconName: active === source ? "check" : undefined,
    reserveLeadingIconSpace: true,
    onClick: () => {
      if (active === source) return;

      persistBackendSource(source);
      window.location.reload();
    },
    dataTestId: `backend-source-${source}`
  };
}

export function getBackendSourceMenuItems(): MenuListEntry[] {
  if (!isBackendSourceToggleAvailable()) {
    return [];
  }

  const active = getActiveBackendSource();

  return [
    { type: "headline", label: "API backend", useDivider: false },
    buildBackendSourceItem("shared-dev", active),
    { ...buildBackendSourceItem("localhost", active), useDivider: true }
  ];
}
